const addBooking = (
	location,
	agentlogin,
	payment,
	payableAmout,
	priceDetails,
	selectedFlight,
	dispatch,
	FlightAddBookingDispatch,
	PGCharge
) => {
	const pselectedPax1 = {
		userEmail: location.state.formData.email,
		userPhone: location.state.formData.phone,
		userPhoneCode: '91',
		adtitle1: location.state.formData.titleA1,
		adfirstname1: location.state.formData.first_nameA1,
		adlastname1: location.state.formData.last_nameA1,
		addob1: '',
	};
	const pselectedPax2 = {
		userEmail: location.state.formData.email,
		userPhone: location.state.formData.phone,
		userPhoneCode: '91',
		adtitle1: location.state.formData.titleA1,
		adfirstname1: location.state.formData.first_nameA1,
		adlastname1: location.state.formData.last_nameA1,
		addob1: '',
		adtitle1: location.state.formData.titleA2,
		adfirstname1: location.state.formData.first_nameA2,
		adlastname1: location.state.formData.last_nameA2,
		addob1: '',
	};
	let formaddBooking = {
		orderId: location.state.orderID,
		supplier: location.state.OneflightData.Supplier,
		userEmail: location.state.formData.email,
		userPhone: location.state.formData.phone,
		user_type: agentlogin ? 'agent' : 'guest',
		origin: location.state.body.Segments[0].Origin,
		destination: location.state.body.Segments[0].Destination,
		travelDate: location.state.body.Segments[0].PreferredDepartureTime,
		returnDate: '',
		journeyType: location.state.body.JourneyType === 1 ? 'OneWay' : '',
		origin1: '',
		destination1: '',
		travelDate1: '',
		origin2: '',
		destination2: '',
		travelDate2: '',
		origin3: '',
		destination3: '',
		travelDate3: '',
		PGCharge: payment === 'pay' ? 200 : 0,
		class: 'Economy',
		nop: `${location.state.body.AdultCount} | ${location.state.body.ChildCount} | ${location.state.body.InfantCount} `,
		airlineType: '',
		carrier: location.state.OneflightData.AirlineCode
			? location.state.OneflightData.AirlineCode
			: location.state.OneflightData.Airline_Code,
		fareType: 'R',
		eTicketType: 'eTicket',
		actualFare: location.state.OneflightData.AirlineCode
			? Number(payableAmout) -
			  Number(Math.round(location.state.OneflightData.Fare.agentMarkup)) -
			  Number(Math.round(location.state.OneflightData.Fare.partnerMarkup)) -
			  Number(Math.round(location.state.OneflightData.Fare.markup))
			: Number(payableAmout) -
			  Number(
					Math.round(
						location.state.OneflightData.Fares[0].FareDetails[0].agentMarkup
					)
			  ) -
			  Number(
					Math.round(
						location.state.OneflightData.Fares[0].FareDetails[0].partnerMarkup
					)
			  ) -
			  Number(
					Math.round(
						location.state.OneflightData.Fares[0].FareDetails[0].markup
					)
			  ),
		markup: location.state.OneflightData.AirlineCode
			? Math.round(location.state.OneflightData.Fare.markup)
			: Math.round(location.state.OneflightData.Fares[0].FareDetails[0].markup),
		baseFare: location.state.OneflightData.AirlineCode
			? Number(
					Number(payableAmout) -
						Number(Math.round(location.state.OneflightData.Fare.agentMarkup)) -
						Number(
							Math.round(location.state.OneflightData.Fare.partnerMarkup)
						) -
						Number(Math.round(location.state.OneflightData.Fare.markup))
			  ) + Number(Math.round(location.state.OneflightData.Fare.markup))
			: Number(
					Number(payableAmout) -
						Number(
							Math.round(
								location.state.OneflightData.Fares[0].FareDetails[0].agentMarkup
							)
						) -
						Number(
							Math.round(
								location.state.OneflightData.Fares[0].FareDetails[0]
									.partnerMarkup
							)
						)
			  ) +
			  Number(
					Math.round(
						location.state.OneflightData.Fares[0].FareDetails[0].markup
					)
			  ),
		partnerMarkup: location.state.OneflightData.AirlineCode
			? Math.round(location.state.OneflightData.Fare.partnerMarkup)
			: Math.round(
					location.state.OneflightData.Fares[0].FareDetails[0].partnerMarkup
			  ),
		agentMarkup: location.state.OneflightData.AirlineCode
			? Math.round(location.state.OneflightData.Fare.agentMarkup)
			: Math.round(
					location.state.OneflightData.Fares[0].FareDetails[0].agentMarkup
			  ),
		totalFare: location.state.OneflightData.AirlineCode
			? Number(
					Number(Math.round(location.state.OneflightData.Fare.BaseFare)) +
						Number(Math.round(location.state.OneflightData.Fare.Tax)) +
						Number(Math.round(location.state.OneflightData.Fare.TdsOnPLB)) +
						Number(Math.round(location.state.OneflightData.Fare.agentMarkup)) -
						Number(
							Math.round(location.state.OneflightData.Fare.CommissionEarned)
						) -
						Number(Math.round(location.state.OneflightData.Fare.PLBEarned))
			  ) - Number(Math.round(location.state.OneflightData.Fare.agentMarkup))
			: Number(
					Number(
						Math.round(
							location.state.OneflightData.Fares[0].FareDetails[0].Basic_Amount
						)
					) +
						Number(
							Math.round(
								location.state.OneflightData.Fares[0].FareDetails[0]
									.AirportTax_Amount
							)
						) -
						Number(
							Math.round(
								location.state.OneflightData.Fares[0].FareDetails[0]
									.Net_Commission
							)
						) +
						Number(
							Math.round(
								location.state.OneflightData.Fares[0].FareDetails[0]
									.Service_Fee_Amount
							)
						) +
						Number(
							Math.round(
								location.state.OneflightData.Fares[0].FareDetails[0].TDS
							)
						) +
						Number(
							Math.round(
								location.state.OneflightData.Fares[0].FareDetails[0].agentMarkup
							)
						) +
						Number(
							Math.round(
								location.state.OneflightData.Fares[0].FareDetails[0]
									.partnerMarkup
							)
						)
			  ) -
			  Number(
					Math.round(
						location.state.OneflightData.Fares[0].FareDetails[0].agentMarkup
					)
			  ),
		payableAmount: payableAmout,
		ticketCost: payableAmout,
		totalEarn: location.state.OneflightData.AirlineCode
			? location.state.OneflightData.Fare.markup
			: location.state.OneflightData.Fares[0].FareDetails[0].markup,
		cashBack: '0.00',
		couponDiscount: 0.0,
		couponDetails: '',
		pricingDetails: priceDetails,
		selectedFlight: selectedFlight,
		airlineType: location.state.OneflightData.Airline_Code
			? location.state.OneflightData.Block_Ticket_Allowed
				? 'LCC'
				: 'GDS'
			: location.state.OneflightData.IsLCC
			? 'LCC'
			: 'GDS',
		selectedPax: location.state.BookingData,
		ticketSent: 0,
		paymentMode: agentlogin
			? payment === 'offline'
				? 'OFFLINE'
				: 'ONLINE'
			: 'ONLINE',
		agent_id: agentlogin ? agentlogin && agentlogin.result.result.id : 0,
	};
	dispatch(FlightAddBookingDispatch(formaddBooking));
};
export default addBooking;
